import { render, staticRenderFns } from "./IntakeBatch.vue?vue&type=template&id=80e367aa"
import script from "./IntakeBatch.vue?vue&type=script&lang=ts"
export * from "./IntakeBatch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports